import React from 'react';
import DatePicker from 'react-date-picker'
type Props = {
  onChange:any;
  value:any;
  defaultValue?:Date;
  isDisabled?:boolean;
  required?:boolean;
  calendarIcon?: JSX.Element
  noCalendarIcon?: boolean,
  noClearIcon?: boolean,
  minDate?: Date
  className?:string;
  format?: string;
};

const DatePickerComponent : React.FC <Props> = ({
  defaultValue,
  onChange,
  value,
  isDisabled,
  required,
  calendarIcon,
  noCalendarIcon,
  noClearIcon,
  minDate,
  className,
  format
}) =>{

  let props: any = {};
  if (isDisabled) {
    props = {calendarIcon: null, clearIcon: null};
  }

  if (calendarIcon) {
    props.calendarIcon = calendarIcon;
  }

  if (calendarIcon) {
    props.calendarIcon = calendarIcon;
  }

  if (noCalendarIcon) props.calendarIcon = null;
  if (noClearIcon) props.clearIcon = null;

  return(
    <DatePicker
      className={className || "form-control"}
      disabled={isDisabled}
      required={required}
      onChange={onChange}
      minDate={minDate}
      format={format}
      {...props}
      value={value ? value : defaultValue}
    />
  );
};

export default DatePickerComponent;
